import type { BaseStreamEvent, StreamEvent, StreamEventMap, StreamEventName } from './streamEvent';

export type StreamEventHandler<K extends StreamEventName> = (
  event: BaseStreamEvent<K, StreamEventMap[K]>,
) => void;

export type StreamEventHandlerMap = {
  [K in StreamEventName]?: StreamEventHandler<K>;
};

export function dispatchStreamEvent(handlers: StreamEventHandlerMap, event: StreamEvent): void {
  const handler = handlers[event.event] as ((e: BaseStreamEvent) => void) | undefined;
  if (handler) handler(event);
}
